import { Routes } from "@angular/router";
import { ClippingStudioRootComponent } from "./clipping-studio-root/clipping-studio-root.component";
import { ClippingStudioComponent } from "./clipping-studio.component";
import { PublishingStatusContainerComponent } from "../publishing-status/publishing-status-container/publishing-status-container.component";
import { MamExplorerContainerComponent } from "../mam-explorer/mam-explorer-container/mam-explorer-container.component";

export const ClippingStudioRoutes: Routes = [
  {
    path: "clipping-studio",
    component: ClippingStudioRootComponent,
    children: [
      {
        path: "",
        component: PublishingStatusContainerComponent,
      },
      {
        path: "mam-explorer",
        component: MamExplorerContainerComponent,
      },
      {
        path: ":publicationUid/edit",
        component: ClippingStudioComponent,
      },
    ],
  },
];
